module.exports = "<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\">\n  <span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span>\n  <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude></span>\n</div>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/third/ui-select/src/selectize/match.tpl.html
// module id = 464
// module chunks = 0